import cloneDeep from 'lodash/cloneDeep'
import { toFilterSets } from '../../utils/filters/filters.generics'
import { BBTreeviewNode, Category, PopulatedCategory } from '../../types'

/**
 * Takes an array of categories with parent and children references, and populates
 * the references with the objects. Internally relies on mutation but should not be
 * mutating input data
 * @param arr flattened array of all category values
 * @returns array of categories with hierarchical populated child categories
 */
export function populateReferences(arr: Array<Category>): Array<PopulatedCategory> {
  const results: Array<PopulatedCategory> = []

  const categories = cloneDeep(arr)

  for (let i = 0; i < categories.length; i++) {
    // grab a mutable reference to the object
    // any casting here since this is dynamically altering the data type
    const category: any = categories[i]
    // if the item has no children, push it directly to the results stack
    if (!category.children || !category?.children?.length) {
      results.push(category)
    }
    if (category?.children?.length) {
      // reassign the referenced child id with the populated child object
      const childCategories = categories.filter(ch => category?.children?.includes(ch._id))
      category.children = childCategories
      results.push(category)
    }
  }
  /**
   * At this point, we have the same number of original items, just with
   * populated children. To get the root nodes so to speak (top level categories),
   * we just filter out to the categories with no parent reference
   */
  return results.filter(cat => !cat.parent)
}

export function categoryToFilterSets(populatedCategories: Array<PopulatedCategory>) {
  const categoryToTreeNode = (category: PopulatedCategory): BBTreeviewNode => {
    return {
      id: category._id,
      name: category.name,
      value: category._id,
      groupingKey: 'category',
      type: 'Checkbox',
      children: category.children?.map(categoryToTreeNode)
    }
  }
  return toFilterSets(populatedCategories, categoryToTreeNode)
}
